import { cancelBook, updateStatus, completeCheckIn, revoke, amend, extend } from '../../services/booking'
import { updateCredit } from '../../services/credit'

const cancelBookingAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowCancelDialog, cancellationCharge, handleUnauth) => {
    return async (e) => {
        try {
            await cancelBook(selectedBooking, cancellationCharge)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings.splice(index, 1)
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Booking Cancelled')
            setSnackType('success')
            setShowCancelDialog(false)
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not cancel booking')
            setSnackType('error')
            setShowCancelDialog(false)
        }
    }
}

const checkoutAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowUpdateStatusDialog, setCurrentNote, setAdvance, currentNote, advance, handleUnauth) => {
    return async (checks) => {
        try {
            const result = await updateStatus(selectedBooking, 'checkedout', currentNote, advance, checks)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].status='checkedout'
            _bookings[index].advance=advance
            _bookings[index].notes.checkoutNotes = currentNote
            _bookings[index].checks = checks
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Checked Out')
            setSnackType('success')
            setShowUpdateStatusDialog(false)
            setCurrentNote('')
            setAdvance(0)
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not checkout')
            setSnackType('error')
            console.log(`checkout ${selectedBooking}`)
        }
    }
}

const checkInAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowUpdateStatusDialog, setCurrentNote, currentNote, handleUnauth) => {
    return async (pendingChecks) => {
        try {
            const result = await updateStatus(selectedBooking, 'checkedin', currentNote, undefined, pendingChecks)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].status='checkedin'
            _bookings[index].pendingChecks=pendingChecks
            _bookings[index].notes.checkinNotes = currentNote
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Checked In')
            setSnackType('success')
            setShowUpdateStatusDialog(false)
            setCurrentNote('')
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not checkin')
            setSnackType('error')
        }
    }
}
const closeAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowUpdateStatusDialog, setCurrentNote, handleUnauth) => {
    return async () =>{
        try {
            const result = await updateStatus(selectedBooking, 'closed')
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].status='closed'
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Closed')
            setSnackType('success')
            setShowUpdateStatusDialog(false)
            setCurrentNote('')
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not close')
            setSnackType('error')
        }
    }
}

const moveToCreditAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowUpdateStatusDialog, setCurrentNote, handleUnauth) => {
    return async() => {
        try {
            const result = await updateCredit(selectedBooking)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].status='credited'
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Credited')
            setSnackType('success')
            setShowUpdateStatusDialog(false)
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            console.log(e)
            setShowSnack(true)
            setSnackMessage('Could not add to credit')
            setSnackType('error')
        }
    }
}

const completeCheckInAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setShowUpdateStatusDialog, setBookings, handleUnauth) => {
    return async (_checks) => {
        try {
            // Find the booking from local memory and make changes while filtering for payload
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            const _pendingChecks = _bookings[index].pendingChecks
            const filteredChecks = Object.fromEntries(
                Object.entries(_checks).filter(([key, value]) =>{ 
                    if (value === true) {
                        delete _pendingChecks[key]
                    }
                    return value === true
                })
            );
            console.log(_pendingChecks, filteredChecks)
            // Make API call
            const result = await completeCheckIn(selectedBooking, filteredChecks)

            // update local memory
            if (Object.keys(_pendingChecks).length > 0) {
                _bookings[index].pendingChecks = _pendingChecks
            } else {
                delete _bookings[index]
            }
            setSnackMessage('Completed')
            setSnackType('success')
            setShowUpdateStatusDialog(false)
            setBookings(_bookings);
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            console.log(e)
            setShowSnack(true)
            setSnackMessage('Could not complete')
            setSnackType('error')
        }
    }
}

const revokeAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowAmend, handleUnauth) => {
    return async() => {
        try {
            const result = await revoke(selectedBooking)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].status='revoked'
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Revoked')
            setSnackType('success')
            setShowAmend(false)
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not revoke')
            setSnackType('error')
        }
    }
}

const amendAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowAmend, handleUnauth) => {
    return async(from, to, discount, amount, billableDates) => {
        try {
            const result = await amend(selectedBooking, from, to, billableDates, discount)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].from = from
            _bookings[index].to = to
            _bookings[index].discount = discount
            _bookings[index].amount = amount
            _bookings[index].billableDates = billableDates
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Amended')
            setSnackType('success')
            setShowAmend(false)
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not amend')
            setSnackType('error')
        }
    }
}

const extendAction = (bookings, selectedBooking, setShowSnack, setSnackMessage, setSnackType, setBookings, setShowExtend, handleUnauth) => {
    return async(to, discount, amount, billableDates) => {
        try {
            const result = await extend(selectedBooking, to, billableDates, discount)
            const _bookings = [...bookings];
            const index = _bookings.findIndex(book => book._id === selectedBooking)
            _bookings[index].to = to
            _bookings[index].discount = discount
            _bookings[index].amount = amount
            _bookings[index].billableDates = billableDates
            setBookings(_bookings);
            setShowSnack(true)
            setSnackMessage('Extended')
            setSnackType('success')
            setShowExtend(false)
        } catch (e) {
            if (e.status === 401) {
                handleUnauth()
            }
            setShowSnack(true)
            setSnackMessage('Could not extend')
            setSnackType('error')
        }
    }
}

  export {
    completeCheckInAction,
    moveToCreditAction,
    closeAction,
    checkInAction,
    checkoutAction,
    cancelBookingAction,
    revokeAction,
    amendAction,
    extendAction
  }